<template>
    <div class="sbs-user-navigation">
        <p class="sbs-user-navigation__info">
            <span class="sbs-user-navigation__name">
                {{ userName }}
            </span>

            <span class="sbs-user-navigation__role">
                {{ userRole }}
            </span>
        </p>

        <SbsPopup
            v-bind="popupData"
            v-model="visible"
            popupClass="sbs-user-navigation__popup">
            <template #content>
                <slot></slot>
            </template>

            <SbsBaseButton
                class="sbs-user-navigation__button trs"
                :bordered="false"
                static
                @click="togglePopupVisibility">
                <SbsAvatar
                    class="sbs-user-navigation__avatar"
                    :name="userName"
                    :imageSrc="avatarImageSrc"
                    :backgroundTheme="avatarBackgroundTheme"
                    :colorTheme="avatarColorTheme" />

                <SbsIcon
                    v-bind="togglerIconData"
                    class="sbs-user-navigation__toggler trs" />
            </SbsBaseButton>
        </SbsPopup>
    </div>
</template>

<script>
import { AllColors } from '../../utils/colors.js';
import { AllSizes } from '../../utils/sizes.js';
import { AllPositions } from '../../utils/positions.js';
import SbsPopup from '../popup/SbsPopup.vue';
import SbsBaseButton from '../button/SbsBaseButton.vue';
import SbsAvatar from '../avatar/SbsAvatar.vue';
import SbsIcon from '../icon/SbsIcon.vue';

export default {
    name: 'SbsUserNavigation',
    emits: ['update:modelValue'],
    components: {
        SbsBaseButton,
        SbsAvatar,
        SbsIcon,
        SbsPopup,
    },
    computed: {
        visible: {
            get() {
                return this.modelValue;
            },
            set(value) {
                /**
                 * Эмит события `update:modelValue`, отвечает за видимость меню пользователя
                 */
                this.$emit('update:modelValue', value);
            },
        },
        popupData() {
            return {
                position: AllPositions.BOTTOM_END,
                showCloseButton: false,
            };
        },
        togglerIconData() {
            return {
                class: {
                    'fa-rotate-180': this.visible,
                },
                iconName: 'chevron-down',
                iconSize: AllSizes.MEDIUM,
            };
        },
    },
    methods: {
        togglePopupVisibility() {
            this.visible = !this.visible;
        },
    },
    props: {
        /**
         * Тема (цветовые решения) для цвета фона
         */
        avatarBackgroundTheme: {
            type: String,
            default: AllColors.PRIMARY,
        },
        /**
         * Тема (цветовые решения) для цвета текста
         */
        avatarColorTheme: {
            type: String,
            default: AllColors.WHITE,
        },
        /**
         * Путь для изображения
         */
        avatarImageSrc: {
            type: String,
            default: '',
        },
        /**
         * Видимость выпадающего меню
         * @model
         */
        modelValue: {
            type: Boolean,
            default: false,
        },
        /**
         * Полное имя пользователя
         */
        userName: {
            type: String,
            default: '',
        },
        /**
         * Роль пользователя
         */
        userRole: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.sbs-user-navigation {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;

    &__info {
        flex-shrink: 0;
        margin-right: 15px;
    }

    &__name {
        display: block;
        color: $black;
        text-align: right;

        @include typo-secondary-demi;
    }

    &__role {
        display: block;
        color: $gray-deep;
        text-align: right;

        @include typo-subsecondary-book;
    }

    &__button {
        display: flex;
        align-items: center;
    }

    &__toggler {
        padding: 10px;
    }

    &__popup {
        padding: 25px 0;
    }
}
</style>
